import { useAppSelector } from 'appState/store'
import { LoadingAnimation } from '@outbound-ai/ursa'
import { useUserProfile } from 'features/settings/settingsHooks'
import { IUserRoleGuidEnum } from 'features/settings/settingsTypes'
import { SetStateAction, useEffect, useState } from 'react'
import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { notificator } from 'utils/notificator/notificator'
import { batchCallinProgress, stopProcessing } from '../autoCheckApi'
import { BatchStatus, BatchTabType } from '../types'
import { createBatchServerSideDataSource } from './grid'

export const handelStopProcessing = (
  params: any,
  setShow: { (value: SetStateAction<boolean>): void; (arg0: boolean): void },
  setLoading: { (value: SetStateAction<boolean>): void; (arg0: boolean): void },
  root: BatchTabType,
) => {
  setLoading(true)
  stopProcessing(params.data.batchId)
    .then((res) => {
      if (res) {
        setShow(false)
        setLoading(false)
        const dataSource = createBatchServerSideDataSource(root)
        params.api.setGridOption('serverSideDatasource', dataSource)
        notificator.notify({
          type: 'info',
          heading: `AutoCheck processing was successfully stopped for  claim file ` + params.data.batchName,
        })
        //notificator.info(`AutoCheck processing was successfully stopped for  claim file ` + params.data.batchName)
      }
    })
    .catch((err) => {
      notificator.notify({
        type: 'error',
        heading: err.response?.data.detail,
      })
      //notificator.error(err.response?.data.detail)
      setShow(false)
      setLoading(false)
      const dataSource = createBatchServerSideDataSource(root)
      params.api.setGridOption('serverSideDatasource', dataSource)
    })
}

export const handelClose = (
  params: any,
  setShow: { (value: SetStateAction<boolean>): void; (arg0: boolean): void },
  root: BatchTabType,
) => {
  setShow(false)
  const dataSource = createBatchServerSideDataSource(root)
  params.api.setGridOption('serverSideDatasource', dataSource)
}

export const formatStopProcessing = (params: any) => {
  const [show, setShow] = useState(false)
  const [callinPogress, setCallinProgress] = useState(0)
  const [loading, setLoading] = useState(false)
  const { user } = useAppSelector((state) => state.auth)
  const { data } = useUserProfile(user?.id)
  const permission = data?.roles.map((role) => role.roleId)
  useEffect(() => {
    if (show) {
      batchCallinProgress(params.data.batchId).then((res) => {
        if (res) {
          setCallinProgress(res.data[0].inProgress)
        }
      })
    }
  }, [show])
  return (
    <Div>
      <span className="action">
        {params.data.status === BatchStatus.Canceling ||
          !permission?.includes(IUserRoleGuidEnum.runAutoCheckPermission) ? (
          <Button variant="danger-outline" size="small" radius="rounded" disabled>
            Stop
          </Button>
        ) : (
          <Button
            variant="danger-outline"
            onClick={() => {
              setShow(true)
            }}
            size="small"
            radius="rounded"
          >
            Stop
          </Button>
        )}
      </span>
      <ObModal
        show={show}
        close={() => setShow(false)}
        title={'Stop AutoCheck processing?'}
        modalFooter={
          <FooterStyle>
            <Button
              variant="danger-outline"
              size="large"
              width="100%"
              radius="rounded"
              onClick={() => handelStopProcessing(params, setShow, setLoading, BatchTabType.Processing)}
            >
              {loading ? (
                <>
                  <LoadingAnimation variant="danger" /> Canceling
                </>
              ) : (
                'Yes, stop processing'
              )}
            </Button>
            <Button
              variant="primary"
              size="large"
              radius="rounded"
              width="100%"
              contentType="text-icon"
              onClick={() => handelClose(params, setShow, BatchTabType.Processing)}
            >
              No, never mind
            </Button>
          </FooterStyle>
        }
      >
        <InnerDiv>
          <p>
            Are you sure you want to stop AutoCheck? Processing will stop after all {callinPogress} call(s) in progress
            have been completed.{' '}
          </p>
        </InnerDiv>
      </ObModal>
    </Div>
  )
}

export const formatCancelRequest = (params: any) => {
  const { user } = useAppSelector((state) => state.auth)
  const { data: profile } = useUserProfile(user?.id)
  const roleIds = profile?.roles.map((role) => role.roleId)
  const isrunAutocheckUser = roleIds?.includes(IUserRoleGuidEnum.runAutoCheckPermission)

  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  return (
    <Div>
      {isrunAutocheckUser && (
        <span className="action">
          {params.data.status === BatchStatus.Canceling ? (
            <Button variant="danger-outline" size="small" radius="rounded" disabled={!isrunAutocheckUser}>
              Cancel Request
            </Button>
          ) : (
            <Button
              variant="danger-outline"
              onClick={() => {
                setShow(true)
              }}
              size="small"
              radius="rounded"
              disabled={!isrunAutocheckUser}
            >
              Cancel Request
            </Button>
          )}
        </span>
      )}

      <ObModal
        show={show}
        close={() => setShow(false)}
        title={'Cancel AutoCheck request?'}
        modalFooter={
          <FooterStyle>
            <Button
              variant="danger-outline"
              size="large"
              width="100%"
              radius="rounded"
              onClick={() => handelStopProcessing(params, setShow, setLoading, BatchTabType.Claims)}
            >
              {loading ? (
                <>
                  <LoadingAnimation variant="danger" /> Canceling
                </>
              ) : (
                'Yes, cancel AutoCheck'
              )}
            </Button>
            <Button
              variant="primary"
              size="large"
              radius="rounded"
              width="100%"
              contentType="text-icon"
              onClick={() => handelClose(params, setShow, BatchTabType.Claims)}
            >
              No, never mind
            </Button>
          </FooterStyle>
        }
      >
        <ContentDivModalCancel>
          <span>
            Are you sure you want to cancel the request for AutoCheck processing of this batch? This cannot be undone.
            Note: some or all claims may have already been imported to the Claims list.
          </span>
        </ContentDivModalCancel>
      </ObModal>
    </Div>
  )
}

const FooterStyle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: -webkit-fill-available;
`

const Div = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: auto;
`
const ContentDivModalCancel = styled.div``

const InnerDiv = styled.div`
  .user-lock-icon {
    font-size: 3rem;
    opacity: 0.6;
    opacity: 0.6;
    margin-right: 1.5rem;
  }
  .alert-info {
    background-color: ${({ theme }) => theme.colors.info.lighter};
    color: ${({ theme }) => theme.colors.primary.darker};
    svg {
      color: ${({ theme }) => theme.colors.info.darker};
    }
    margin-bottom: 1rem;
  }
  .button-holder {
    display: flex !important;
    gap: 10px !important;
    justify-content: space-between !important;
    margin-left: 108px !important;
  }
  .info {
    font-size: 16px;
    font-weight: 600;
    margin-left: 1.5rem;
  }
  .user-lock-container {
    display: flex;
    align-items: center;
  }
  .user-lock-container h3 {
    font-family: 'Milliard';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: ${({ theme }) => theme.colors.primary.darker};
    span {
      float: right;
      text-align: right;
      margin-left: 13rem;
      svg {
        color: ${({ theme }) => theme.colors.primary.darker};
        cursor: pointer;
      }
    }
  }
  p {
    margin-bottom: 1rem;
    font-family: 'Milliard';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  .take-ownership-btn {
    width: 184px;
    height: 2.75rem;
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    align-items: center;
    padding: 1rem 1rem;
    border: 2px solid #d53f3f;
    border-radius: 0.625rem;
    font-family: 'Milliard';
    font-style: normal;
    font-weight: 500;
    margin-right: 1.5rem;
    font-size: 16px;
    line-height: 150%;
    color: #d53f3f;
  }
  .cancel-btn {
    width: 164px;
    height: 2.75rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1.25rem 1.875rem;
    background: ${({ theme }) => theme.colors.primary.darker};
    border-radius: 0.625rem;
  }
`
